import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {jwtDecode} from "jwt-decode";

const Header = ({ authenticated }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const token = localStorage.getItem("AuthToken");
    const location = useLocation(); // Obtener la ubicación actual

    let tokenInfo = {};
    if (token) {
        tokenInfo = jwtDecode(token);
    } 
    let profilePicUrl = "/images/usuario.svg";
    if (tokenInfo.fotoPerfil && tokenInfo.fotoPerfil !== "none") {
      profilePicUrl = tokenInfo.fotoPerfil;
    }
    const handleLinkClick = () => {
        window.scrollTo(0, 0);
        const checkbox = document.getElementById("menu-toggle");
        if (checkbox) {
            checkbox.checked = false;
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("AuthToken");
        window.location.reload();
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className={isScrolled ? 'scrolled' : ''}>
            <div className='site-width grid-header'>
                <Link to="/" className='logo-link' onClick={handleLinkClick}
>
                    <img className='header-logo' src='/images/logoadhoc-negro.svg' alt='Logo ADHOC'/>
                    <p>Holded</p>
                </Link>
                {
                    authenticated && (
                        <div className="grid-menu">
                            <div className="menu">
                            <Link 
                                to='/servicios-y-clientes' 
                                className={location.pathname === '/servicios-y-clientes' ? 'active' : ''} // Añadir clase 'active' si la ruta es '/panel'
                                onClick={handleLinkClick}
                            >
                                Servicios & Clientes
                            </Link>
                            <Link 
                                to='/contabilidad' 
                                className={location.pathname === '/contabilidad' ? 'active' : ''} // Añadir clase 'active' si la ruta es '/panel'
                                onClick={handleLinkClick}
                            >
                                Contabilidad
                            </Link>
                            <Link 
                                to='/empleados' 
                                className={location.pathname === '/empleados' ? 'active' : ''} // Añadir clase 'active' si la ruta es '/panel'
                                onClick={handleLinkClick}
                            >
                                Empleados
                            </Link>
                            <Link 
                                to='/ventas' 
                                className={location.pathname === '/ventas' ? 'active' : ''} // Añadir clase 'active' si la ruta es '/panel'
                                onClick={handleLinkClick}
                            >
                                Ventas
                            </Link>
                            <Link 
                                to='/tareas-pendientes' 
                                className={location.pathname === '/tareas-pendientes' ? 'active' : ''} // Añadir clase 'active' si la ruta es '/panel'
                                onClick={handleLinkClick}
                            >
                                Tareas Pendientes
                            </Link>
                        </div>
                        <Link to={'/perfil'} onClick={() => window.scrollTo(0, 0)} className='profilelink'><div className='profile'>
                            <img src={profilePicUrl} alt="Usuario" className='profile-pic'/>
                            <div className="profile-info">
                                {tokenInfo.nombre && tokenInfo.apellidos && (
                                    <p className='profile-name'>{tokenInfo.nombre} {tokenInfo.apellidos}
                                    <br/>
                                    <span>@{tokenInfo.usuario}</span></p>
                                )}
                            </div>
                            <button className='logout' onClick={handleLogout}>
                                <img src="/images/dejar.svg" alt="Logout" />                                    
                            </button>
                        </div></Link>
                        </div>
                    )
                }

        
                <div className="adhoc-burger">
                    <input type="checkbox" id="menu-toggle" />
                    <label htmlFor="menu-toggle" className="menu-icon">
                        <div className="line top"></div>
                        <div className="line bottom"></div>
                    </label>
                    <div className="menu-responsive">
                        <Link to="/" className='logo-link' onClick={handleLinkClick}>
                            <img className='lateral-logo' src='/images/logoadhoc-negro.svg' alt='Logo ADHOC'/>
                        </Link>   
                        <div className="user-actions">
                            {authenticated ? (
                                <>
                                    <Link 
                                        to="/panel" 
                                        className={`dashboard ${location.pathname === '/panel' ? 'active' : ''}`} // Clase 'active' condicional
                                        onClick={handleLinkClick}
                                    >
                                        Mi panel
                                    </Link>
                                    <button className='logout' onClick={handleLogout}>
                                        <img src="/images/cerrar-sesion.svg" alt="Logout" />
                                        <p>Salir</p>
                                    </button>
                                </>
                            ) : (
                                <Link to="/iniciar-sesion" className='login'>
                                    Iniciar sesión
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
